/**
 * Initialize the section navigation block.
 *
 * @return {void}
 */
function initSectionNavigation() {
	const sectionNavs = document.querySelectorAll(
		'.paragon-section-navigation-block'
	);

	// If there are no section navigation blocks, don't do anything.
	if (!sectionNavs.length) {
		return;
	}

	const siteHeader = document.querySelector('#masthead');

	sectionNavs.forEach((sectionNav) => {
		// on scroll, if the top of the section nav is touching the header, add a "stuck" class
		window.addEventListener('scroll', () => {
			if (
				window.scrollY > 5 &&
				siteHeader.classList.contains('shrunken') &&
				siteHeader.getBoundingClientRect().bottom >=
					sectionNav.getBoundingClientRect().top - 5
			) {
				sectionNav.classList.add('stuck');
			} else {
				sectionNav.classList.remove('stuck');
			}
		});
	});
}

document.addEventListener('DOMContentLoaded', function () {
	initSectionNavigation();
});
